import * as React from 'react';

function ConversantLevelBar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={60} height={4} viewBox="0 0 60 4" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M2 0h9v4H2a2 2 0 110-4z" fill="var(--cds-color-yellow-200)" />
        <path d="M47 0h11a2 2 0 110 4H47V0zM13 0h12v4H13zm14 0h18v4H27z" fill="var(--cds-color-grey-25)" />
      </g>
    </svg>
  );
}

export default ConversantLevelBar;
